import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../../../../app/shared/services/apiService.service';
import { ToastrService } from 'ngx-toastr';
import { Options } from "@angular-slider/ngx-slider";
import { RegexService } from '../../../form-validation/regex.service';
import { isPlatformBrowser } from '@angular/common';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
@Component({
  selector: 'app-unbox-filter',
  templateUrl: './unbox-filter.component.html',
  styleUrls: ['./unbox-filter.component.scss']
})
export class UnboxFilterComponent implements OnInit {
  sub: Subscription = new Subscription
  subLobfilterList: any;
  final_filter: any[] = [];
  original_final_filter:any[]=[];
  filterName: any[] = []
  filterList: any = []
  tempFilterArray: any[];
  actual_lob_name: any = [];
  pl_name: any = [];
  lob_name: any = [];
  vehicle_acpplication: any = [];
  ModelName: any = [];
  ppl_name: any = [];
  gvwFilterSelected: any = [];
  fuelFilterSelected: any = [];
  acFilterSelected: any = [];
  loadBodyFilterSelected: any = [];
  cabinTypeFilterSelected: any = [];
  wheelsFilterSelected: any = [];
  bodyTypeFilterSelected: any = [];
  floorValue: number;
  ceilValue: number;
  onPageLoad = false;
  tempMaxValue: number
  searchTotal: any = 0;
  usageCount: number = 0;
  segmentCount: any = 0;
  mainVehicleCount: any = 0;
  modelCount: any = 0;
  tonnageCount: any = 0;
  fuelCount: any = 0;
  acCount: any = 0;
  bodyCount: any = 0;
  loadBodyCount: any = 0;
  cabinTypeCount: any = 0;
  wheelCount: any = 0;
  wheelbasecount:any=0;
  searchData: string;
checkDisplayname:any;
  constructor(private activatedRoute: ActivatedRoute, private behaviourSub: BehaviourSubjectService,
    private localStorage: secureStorage, private behaviorService: BehaviourSubjectService,
    private apiService: ApiService, private toastrService: ToastrService, private regexService: RegexService,
    @Inject(PLATFORM_ID) private platformId: Object) { }
  data: any = {
    "data": [
      {
        "key": "Segment",
        "priority": "1",
        "isvisible": "1"
      },
      {
        "key": "Usage",
        "priority": "0",
        "isvisible": "1"
      },

      {
        "key": "Main Vehicle Category",
        "priority": "2",
        "isvisible": "1"
      },
      {
        "key": "Model",
        "priority": "3",
        "isvisible": "1"
      },
      {
        "key": "Budget",
        "priority": "4",
        "isvisible": "1"
      },
      {
        "key": "Tonnage (Gross Vehicle Weight) & Wheels",
        "priority": "5",
        "isvisible": "1"
      },
      {
        "key": "Fuel Type",
        "priority": "6",
        "isvisible": "1"
      },
      {
        "key": "Air Conditioning",
        "priority": "7",
        "isvisible": "1"
      },
      {
        "key": "Body",
        "priority": "8",
        "isvisible": "1"
      },
      {
        "key": "Load Body Length",
        "priority": "9",
        "isvisible": "1"
      },
      {
        "key": "Cabin Type",
        "priority": "10",
        "isvisible": "1"
      },
      {
        "key": "Wheels",
        "priority": "11",
        "isvisible": "1"
      }
    ]
  }

  minValue: number = 0;
  maxValue: number;
  ssoptions: Options = {
    floor: 0,
    ceil: 937546,
    enforceStep: false,
    enforceRange: false,
  };
  unbxFilter: any = [];
  //adding budget slider


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
       this.usageCount = this.filterList.filter((obj) => obj.category === 'vehicle_application_uFilter')?.length;
    this.segmentCount = this.filterList.filter((obj) => obj.category === 'lob_uFilter')?.length;
    this.mainVehicleCount = this.filterList.filter((obj) => obj.category === 'ppl_uFilter')?.length;
    this.modelCount = this.filterList.filter((obj) => obj.category === 'model_uFilter')?.length;
    this.tonnageCount = this.filterList.filter((obj) => obj.category === 'gvw_uFilter')?.length;
    this.fuelCount = this.filterList.filter((obj) => obj.category === 'fuel_type_uFilter')?.length;
    this.acCount = this.filterList.filter((obj) => obj.category === 'air_conditioning_uFilter')?.length;
    this.bodyCount = this.filterList.filter((obj) => obj.category === 'Body')?.length;
    this.loadBodyCount = this.filterList.filter((obj) => obj.category === 'load_body_length_uFilter')?.length;
    this.cabinTypeCount = this.filterList.filter((obj) => obj.category === 'cabin_type_uFilter')?.length;
    this.wheelCount = this.filterList.filter((obj) => obj.category === 'no_wheels_uFilter')?.length;
    this.wheelbasecount = this.filterList.filter((obj) => obj.category === 'wheelbase_uFilter')?.length;
      // this.unbxFilter=[]
      // this.unbxFilter = JSON.parse(this.localStorage.getItem("sideFilter"))
      // // this.final_filter = this.unbxFilter
      // this.final_filter = this.transformData( this.unbxFilter);
      this.sub.add(this.behaviorService.isUnbxFilterChange.subscribe((res) => {
        this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
        if (this.filterList?.length==0) {
          this.usageCount = 0;
          this.segmentCount = 0;
          this.mainVehicleCount = 0;
          this.modelCount = 0;
          this.tonnageCount = 0;
          this.fuelCount = 0;
          this.acCount = 0;
          this.bodyCount = 0;
          this.loadBodyCount = 0;
          this.cabinTypeCount = 0;
          this.wheelCount = 0;
          this.wheelbasecount=0;
        }
        this.unbxFilter=[]
        this.unbxFilter = JSON.parse(this.localStorage.getItem("sideFilter"))
        this.final_filter = this.unbxFilter
        this.final_filter = this.transformData(this.final_filter);
        let store= localStorage.getItem('unbxFilterValue')
        let data:any[]=JSON.parse(store);
        if (data?.length >0) {
        this.updateCheckedStatus(data,this.final_filter)
        }
        // let rowdata=localStorage.getItem('tempFilterArrayrowdata');
        // let val=localStorage.getItem('tempFilterArrayvalue');
        // let rowdata1=JSON.parse(rowdata)
        // let val1=JSON.parse(val)
        // if (rowdata?.length>0) {
        //   this.searchFilter(rowdata1,val1)
        // }

      }));
      this.behaviorService.isSearch.subscribe((res)=>{
        if (res) {
          this.clearAllFilter('Clear')
        }
      })
      var vanType = ""
      this.activatedRoute.paramMap.subscribe(params => {
        this.subLobfilterList = "data";
        vanType = params.get('lob_name');
        if (params.get('search')) {
          this.searchData = params.get('search');
        }
        this.updateFilterSelectedArrays();
      });
      this.sub.add(this.behaviourSub.isMobileFilter.subscribe(data => {
        if (data == 'rowLimit') {
          if (isPlatformBrowser(this.platformId)) {
            this.searchTotal = localStorage.getItem('rowLimit');
          }
        }
      }))
      this.sub.add(this.behaviourSub.filterValue.subscribe(params => {
        if (params != true && params != false) {
          if (params != 'Header' && params != 'Explore') {
            if (params == 'Budget') {
              if (isPlatformBrowser(this.platformId)) {

                let filterValue: any = []
                filterValue = JSON.parse(localStorage.getItem("unbxFilterValue"))
                if (filterValue?.length > 0) {
                  let i = filterValue.findIndex(element => element.category == 'price_from')
                  filterValue.splice(i, 1);
                  let t = filterValue.findIndex(element => element.category == 'price_to')
                  filterValue.splice(t, 1);
                  localStorage.setItem("unbxFilterValue", JSON.stringify(filterValue))
                  this.minValue = 0

                } else {

                }
              }
            }
            else {
              for (let j = 0; j < this.final_filter?.length; j++) {

                if (this.final_filter[j].values) {
                  for (let i = 0; i < this.final_filter[j].values?.length; i++) {
                    if (this.final_filter[j].values[i].value == params) {
                      this.final_filter[j].values[i].checked = false;
                      let filterValue: any = []
                      if (isPlatformBrowser(this.platformId)) {

                        filterValue = JSON.parse(localStorage.getItem("unbxFilterValue"))
                      }

                      if (filterValue?.length > 0) {
                        if (filterValue.find(element => element.event == params)) {
                          let i = filterValue.findIndex(element => element.event == params)

                          this.generateFilterArray(filterValue[i].category, params, 'params');
                          filterValue.splice(i, 1)
                          if (isPlatformBrowser(this.platformId)) {

                            localStorage.setItem("unbxFilterValue", JSON.stringify(filterValue))
                          }
                        } else {

                        }
                      } else {

                      }

                    }

                  }
                }

              }
            }
          }
          else if (params == 'Header') {
            if (isPlatformBrowser(this.platformId)) {

              localStorage.removeItem('unbxFilterValue');
            }
          }
        }
        else {
          let filterValue: any = []
          if (isPlatformBrowser(this.platformId)) {

            filterValue = JSON.parse(localStorage.getItem("unbxFilterValue"))
          }
          if (filterValue?.length > 0) {
            let i = filterValue.findIndex(element => element.category == 'price_from')
            this.minValue = filterValue[i]?.event
            let t = filterValue.findIndex(element => element.category == 'price_to')
            this.tempMaxValue = filterValue[t]?.event
          }
        }
      }))

      if (this.subLobfilterList) {
        for (const values in this.data) {
          if (values == this.subLobfilterList) {
            this.filterName = (this.data[values]).sort((a: any, b: any) => a.priority - b.priority);
          }
        }

      }
      setTimeout(() => {
        this.sub.add(this.behaviourSub.budgetFilter.subscribe((res: any) => {
          this.maxValue = res?.maxValue ? res?.maxValue : this.tempMaxValue
          const newOptions: Options = Object.assign({}, this.ssoptions);
          newOptions.ceil = this.maxValue;
          this.ssoptions = newOptions;
        }));

      }, 500);

      this.updateFilterSelectedArrays()
    }
  }

  updateFilterSelectedArrays() {
    let filterValue: any = []
    if (isPlatformBrowser(this.platformId)) {
      filterValue = JSON.parse(localStorage.getItem("unbxFilterValue"))
    }


    if (filterValue?.length > 0) {
      for (let i = 0; i < filterValue?.length; i++) {

        this.generateFilterArray(filterValue[i].category, filterValue[i].event)
      }
      if (this.activatedRoute.snapshot.params['sub_lob']) {

        this.actual_lob_name.push(this.activatedRoute.snapshot.params['sub_lob'])
      }
      this.ppl_name = []
      if (this.activatedRoute.snapshot.params['ppl_name']) {

        this.ppl_name.push(this.activatedRoute.snapshot.params['ppl_name']);
      }
    }
    else {
      this.vehicle_acpplication = [];
      this.actual_lob_name = [];
      this.ModelName = [];
      this.ppl_name = [];
      this.gvwFilterSelected = [];
      this.fuelFilterSelected = [];
      this.acFilterSelected = [];
      this.loadBodyFilterSelected = [];
      this.cabinTypeFilterSelected = [];
      this.wheelsFilterSelected = [];
      this.bodyTypeFilterSelected = [];
      if (this.activatedRoute.snapshot.params['sub_lob']) {
        this.actual_lob_name.push(this.activatedRoute.snapshot.params['sub_lob']);
      }
      if (this.activatedRoute.snapshot.params['ppl_name']) {
        this.ppl_name.push(this.activatedRoute.snapshot.params['ppl_name']);
      }
    }

    this.getDropDownValues();
  }
  getDropDownValues()
  {
      // this.final_filter = response.data
      var result = Object.entries(this.final_filter);
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Usage' && result[i][0] == 'vehicle_application') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Segment' && result[i][0] == 'lob') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Main Vehicle Category' && result[i][0] == 'ppl') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Tonnage (Gross Vehicle Weight) & Wheels' && result[i][0] == 'gvw') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Model' && result[i][0] == 'model') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Air Conditioning' && result[i][0] == 'air_conditioning') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Fuel Type' && result[i][0] == 'fuel_type') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Body' && result[i][0] == 'body_type') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Load Body Length' && result[i][0] == 'load_body_length') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Cabin Type' && result[i][0] == 'cabin_type') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (this.filterName[j].key == 'Wheels' && result[i][0] == 'wheels') {
            let data: any = result[i][1]
            let formatData: any = []
            data.forEach((e: any) => {
              formatData.push({ key: e, checked: false })
            })
            this.filterName[j]['data'] = formatData
          }
        }
      }

      let filterValue: any = []
      if (isPlatformBrowser(this.platformId)) {

      filterValue = JSON.parse(localStorage.getItem("unbxFilterValue"))
      if (filterValue?.length > 0) {
        for (let i = 0; i < filterValue?.length; i++) {
          for (let j = 0; j < this.filterName?.length; j++) {
            if (filterValue[i].category == this.filterName[j].key) {
              for (let k = 0; k < this.filterName[j].values?.length; k++) {
                if (this.filterName[j].data[k].key == filterValue[i].event) {
                  this.filterName[j].data[k].checked = true;
                }
              }
            }
          }
        }
      }
      // this.tempFilterArray = this.filterName
      // localStorage.setItem('tempFilterArray', JSON.stringify(this.tempFilterArray))
    }

  }
  transformData(data) {
    return data.map(facet => ({
        ...facet,
        values: facet.values.reduce((acc, value, index, array) => {
            if (index % 2 === 0) {
              if (acc.checked) {

              }
                acc.push({ value: value, count: array[index + 1], checked:false });
            }
            return acc;
        }, [])
    }));
}
  onCheckedClick(event: any, cateogry: any,displayName:any) {
this.checkDisplayname=displayName

// for (let j = 0; j < this.final_filter?.length; j++) {
//   if (this.final_filter[j].values) {
//       for (let i = 0; i < this.final_filter[j].values?.length; i++) {

//           if (this.final_filter[j].displayName == displayName) {
//               this.final_filter[j].values[i].checked = true;
//               this.final_filter[j].category = cateogry;
//           }
//       }
//   }
// }

for (let j = 0; j < this.final_filter?.length; j++) {
  if (this.final_filter[j].displayName === displayName) {
      for (let i = 0; i < this.final_filter[j].values?.length; i++) {
          if (this.final_filter[j].values[i].value === event) {
              this.final_filter[j].values[i].checked = true;
              this.final_filter[j].category = cateogry;
          }
      }
  }
}


    if (isPlatformBrowser(this.platformId)) {

      this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
      if (this.filterList?.length > 0) {

        if (this.filterList.find(element => element.event == event)) {
          let i = this.filterList.findIndex(element => element.event == event)
          this.filterList.splice(i, 1);
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
        } else {
          this.filterList.push({ event: event, category: cateogry })
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
        }
      } else {
        if (this.filterList == null) {
          this.filterList = [];
        }
        this.filterList.push({ event: event, category: cateogry })
        localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
      }
    }

    this.usageCount = this.filterList.filter((obj) => obj.category === 'vehicle_application_uFilter')?.length;
    this.segmentCount = this.filterList.filter((obj) => obj.category === 'lob_uFilter')?.length;
    this.mainVehicleCount = this.filterList.filter((obj) => obj.category === 'ppl_uFilter')?.length;
    this.modelCount = this.filterList.filter((obj) => obj.category === 'model_uFilter')?.length;
    this.tonnageCount = this.filterList.filter((obj) => obj.category === 'gvw_uFilter')?.length;
    this.fuelCount = this.filterList.filter((obj) => obj.category === 'fuel_type_uFilter')?.length;
    this.acCount = this.filterList.filter((obj) => obj.category === 'air_conditioning_uFilter')?.length;
    this.bodyCount = this.filterList.filter((obj) => obj.category === 'Body')?.length;
    this.loadBodyCount = this.filterList.filter((obj) => obj.category === 'load_body_length_uFilter')?.length;
    this.cabinTypeCount = this.filterList.filter((obj) => obj.category === 'cabin_type_uFilter')?.length;
    this.wheelCount = this.filterList.filter((obj) => obj.category === 'no_wheels_uFilter')?.length;
    this.wheelbasecount = this.filterList.filter((obj) => obj.category === 'wheelbase_uFilter')?.length;
    this.behaviourSub.isFilterChange.next(true)

    // this.generateFilterArray(displayName,event);
    // this.getDropDownValues();
    let store= localStorage.getItem('unbxFilterValue')
    let data:any[]=JSON.parse(store);
    this.updateCheckedStatus(data,this.final_filter)
  }

  updateCheckedStatus(events, filters) {
    const eventSet = new Set(events.map(eventObj => eventObj.event));

    filters.forEach(filter => {
      filter.values.forEach(valueObj => {
        if (eventSet.has(valueObj.value)) {
          valueObj.checked = true;
        } else {
          valueObj.checked = false;
        }
      });
    });
  }

  generateFilterArray(cateogry, event, flag?) {

    this.vehicle_acpplication = this.vehicle_acpplication == undefined ? [] : this.vehicle_acpplication;
    this.actual_lob_name = this.actual_lob_name == undefined ? [] : this.actual_lob_name;
    this.ModelName = this.ModelName == undefined ? [] : this.ModelName;
    this.ppl_name = this.ppl_name == undefined ? [] : this.ppl_name;
    this.gvwFilterSelected = this.gvwFilterSelected == undefined ? [] : this.gvwFilterSelected;
    this.fuelFilterSelected = this.fuelFilterSelected == undefined ? [] : this.fuelFilterSelected;
    this.acFilterSelected = this.acFilterSelected == undefined ? [] : this.acFilterSelected;
    this.loadBodyFilterSelected = this.loadBodyFilterSelected == undefined ? [] : this.loadBodyFilterSelected;
    this.cabinTypeFilterSelected = this.cabinTypeFilterSelected == undefined ? [] : this.cabinTypeFilterSelected;
    this.wheelsFilterSelected = this.wheelsFilterSelected == undefined ? [] : this.wheelsFilterSelected;
    this.bodyTypeFilterSelected = this.bodyTypeFilterSelected == undefined ? [] : this.bodyTypeFilterSelected;
    let data: any = {};
    if (cateogry == 'Usage') {
      data['vehicle_application'] = event;
      if (this.vehicle_acpplication.find(element => element == data.vehicle_application)) {
        let i = this.vehicle_acpplication.findIndex(element => element == data.vehicle_application)
        this.vehicle_acpplication.splice(i, 1);
      } else {
        this.vehicle_acpplication.push(data.vehicle_application)
      }
    }
    if (cateogry == 'Segment') {

      data['actual_lob_name'] = event;
      if (this.actual_lob_name.find(element => element == data.actual_lob_name)) {
        let i = this.actual_lob_name.findIndex(element => element == data.actual_lob_name)
        this.actual_lob_name.splice(i, 1);

      } else {
        this.actual_lob_name.push(data.actual_lob_name)
      }
    }
    if (cateogry == 'Main Vehicle Category') {
      data['ppl_name'] = event;
      if (this.ppl_name.find(element => element == data.ppl_name)) {
        let i = this.ppl_name.findIndex(element => element == data.ppl_name)
        this.ppl_name.splice(i, 1);
      } else {
        this.ppl_name.push(data.ppl_name)
      }
    }
    if (cateogry == 'Model') {
      data['model'] = event;
      if (this.ModelName.find(element => element == data.model)) {
        let i = this.ModelName.findIndex(element => element == data.model)
        this.ModelName.splice(i, 1);
      } else {
        this.ModelName.push(data.model)
      }
    }
    if (cateogry == 'Tonnage (Gross Vehicle Weight) & Wheels') {
      data['gvw'] = event;
      if (this.gvwFilterSelected.find(element => element == data.gvw)) {
        let i = this.gvwFilterSelected.findIndex(element => element == data.gvw)
        this.gvwFilterSelected.splice(i, 1);
      } else {
        this.gvwFilterSelected.push(data.gvw)
      }
    }
    if (cateogry == 'Fuel Type') {
      data['fuel_type'] = event;
      if (this.fuelFilterSelected.find(element => element == data.fuel_type)) {
        let i = this.fuelFilterSelected.findIndex(element => element == data.fuel_type)
        this.fuelFilterSelected.splice(i, 1);
      } else {
        this.fuelFilterSelected.push(data.fuel_type)
      }
    }
    if (cateogry == 'Air Conditioning') {
      data['air_conditioning'] = event;
      if (this.acFilterSelected.find(element => element == data.air_conditioning)) {
        let i = this.acFilterSelected.findIndex(element => element == data.air_conditioning)
        this.acFilterSelected.splice(i, 1);
      } else {
        this.acFilterSelected.push(data.air_conditioning)
      }
    }
    if (cateogry == 'Load Body Length') {
      data['load_body_length'] = event;
      if (this.loadBodyFilterSelected.find(element => element == data.load_body_length)) {
        let i = this.loadBodyFilterSelected.findIndex(element => element == data.load_body_length)
        this.loadBodyFilterSelected.splice(i, 1);
      } else {
        this.loadBodyFilterSelected.push(data.load_body_length)
      }
    }
    if (cateogry == 'Cabin Type') {
      data['cabin_type'] = event;
      if (this.cabinTypeFilterSelected.find(element => element == data.cabin_type)) {
        let i = this.cabinTypeFilterSelected.findIndex(element => element == data.cabin_type)
        this.cabinTypeFilterSelected.splice(i, 1);
      } else {
        this.cabinTypeFilterSelected.push(data.cabin_type)
      }
    }
    if (cateogry == 'Wheels') {
      data['wheels'] = event;
      if (this.wheelsFilterSelected.find(element => element == data.wheels)) {
        let i = this.wheelsFilterSelected.findIndex(element => element == data.wheels)
        this.wheelsFilterSelected.splice(i, 1);
      } else {
        this.wheelsFilterSelected.push(data.wheels)
      }
    }
    if (cateogry == 'Body') {
      data['body_type'] = event;
      if (this.bodyTypeFilterSelected.find(element => element == data.body_type)) {
        let i = this.bodyTypeFilterSelected.findIndex(element => element == data.body_type)
        this.bodyTypeFilterSelected.splice(i, 1);
      } else {
        this.bodyTypeFilterSelected.push(data.body_type)
      }
    }
    if (cateogry == 'Cabin Type') {
      data['price'] = event;
    }

    if (flag == 'params') {
      // this.getDropDownValues()
    }

  }
  generateFilterArray2(cateogry, event, flag?) {

    this.vehicle_acpplication = this.vehicle_acpplication == undefined ? [] : this.vehicle_acpplication;
    this.actual_lob_name = this.actual_lob_name == undefined ? [] : this.actual_lob_name;
    this.ModelName = this.ModelName == undefined ? [] : this.ModelName;
    this.ppl_name = this.ppl_name == undefined ? [] : this.ppl_name;
    this.gvwFilterSelected = this.gvwFilterSelected == undefined ? [] : this.gvwFilterSelected;
    this.fuelFilterSelected = this.fuelFilterSelected == undefined ? [] : this.fuelFilterSelected;
    this.acFilterSelected = this.acFilterSelected == undefined ? [] : this.acFilterSelected;
    this.loadBodyFilterSelected = this.loadBodyFilterSelected == undefined ? [] : this.loadBodyFilterSelected;
    this.cabinTypeFilterSelected = this.cabinTypeFilterSelected == undefined ? [] : this.cabinTypeFilterSelected;
    this.wheelsFilterSelected = this.wheelsFilterSelected == undefined ? [] : this.wheelsFilterSelected;
    this.bodyTypeFilterSelected = this.bodyTypeFilterSelected == undefined ? [] : this.bodyTypeFilterSelected;
    let data: any = {};
    if (cateogry == 'vehicle_application_uFilter') {
      data['vehicle_application'] = event;
      if (this.vehicle_acpplication.find(element => element == data.vehicle_application)) {
        let i = this.vehicle_acpplication.findIndex(element => element == data.vehicle_application)
        this.vehicle_acpplication.splice(i, 1);
      } else {
        this.vehicle_acpplication.push(data.vehicle_application)
      }
    }
    if (cateogry == 'lob_uFilter') {

      data['actual_lob_name'] = event;
      if (this.actual_lob_name.find(element => element == data.actual_lob_name)) {
        let i = this.actual_lob_name.findIndex(element => element == data.actual_lob_name)
        this.actual_lob_name.splice(i, 1);

      } else {
        this.actual_lob_name.push(data.actual_lob_name)
      }
    }
    if (cateogry == 'ppl_uFilter') {
      data['ppl_name'] = event;
      if (this.ppl_name.find(element => element == data.ppl_name)) {
        let i = this.ppl_name.findIndex(element => element == data.ppl_name)
        this.ppl_name.splice(i, 1);
      } else {
        this.ppl_name.push(data.ppl_name)
      }
    }
    if (cateogry == 'model_uFilter') {
      data['model'] = event;
      if (this.ModelName.find(element => element == data.model)) {
        let i = this.ModelName.findIndex(element => element == data.model)
        this.ModelName.splice(i, 1);
      } else {
        this.ModelName.push(data.model)
      }
    }
    if (cateogry == 'Tonnage (Gross Vehicle Weight) & Wheels') {
      data['gvw'] = event;
      if (this.gvwFilterSelected.find(element => element == data.gvw)) {
        let i = this.gvwFilterSelected.findIndex(element => element == data.gvw)
        this.gvwFilterSelected.splice(i, 1);
      } else {
        this.gvwFilterSelected.push(data.gvw)
      }
    }
    if (cateogry == 'Fuel Type') {
      data['fuel_type'] = event;
      if (this.fuelFilterSelected.find(element => element == data.fuel_type)) {
        let i = this.fuelFilterSelected.findIndex(element => element == data.fuel_type)
        this.fuelFilterSelected.splice(i, 1);
      } else {
        this.fuelFilterSelected.push(data.fuel_type)
      }
    }
    if (cateogry == 'Air Conditioning') {
      data['air_conditioning'] = event;
      if (this.acFilterSelected.find(element => element == data.air_conditioning)) {
        let i = this.acFilterSelected.findIndex(element => element == data.air_conditioning)
        this.acFilterSelected.splice(i, 1);
      } else {
        this.acFilterSelected.push(data.air_conditioning)
      }
    }
    if (cateogry == 'Load Body Length') {
      data['load_body_length'] = event;
      if (this.loadBodyFilterSelected.find(element => element == data.load_body_length)) {
        let i = this.loadBodyFilterSelected.findIndex(element => element == data.load_body_length)
        this.loadBodyFilterSelected.splice(i, 1);
      } else {
        this.loadBodyFilterSelected.push(data.load_body_length)
      }
    }
    if (cateogry == 'Cabin Type') {
      data['cabin_type'] = event;
      if (this.cabinTypeFilterSelected.find(element => element == data.cabin_type)) {
        let i = this.cabinTypeFilterSelected.findIndex(element => element == data.cabin_type)
        this.cabinTypeFilterSelected.splice(i, 1);
      } else {
        this.cabinTypeFilterSelected.push(data.cabin_type)
      }
    }
    if (cateogry == 'Wheels') {
      data['wheels'] = event;
      if (this.wheelsFilterSelected.find(element => element == data.wheels)) {
        let i = this.wheelsFilterSelected.findIndex(element => element == data.wheels)
        this.wheelsFilterSelected.splice(i, 1);
      } else {
        this.wheelsFilterSelected.push(data.wheels)
      }
    }
    if (cateogry == 'Body') {
      data['body_type'] = event;
      if (this.bodyTypeFilterSelected.find(element => element == data.body_type)) {
        let i = this.bodyTypeFilterSelected.findIndex(element => element == data.body_type)
        this.bodyTypeFilterSelected.splice(i, 1);
      } else {
        this.bodyTypeFilterSelected.push(data.body_type)
      }
    }
    if (cateogry == 'Cabin Type') {
      data['price'] = event;
    }

    if (flag == 'params') {
      // this.getDropDownValues()
    }

  }

  clearAllFilter(flag) {
    // let data=localStorage.getItem('tempFilterArrayrowdata');
    // if (data) {
    //   this.clearFi();
    //   localStorage.removeItem('tempFilterArrayrowdata')
    //   localStorage.removeItem('tempFilterArrayvalue')
    // }
    if (isPlatformBrowser(this.platformId)) {
    if (flag == 'Mobile') {
      this.usageCount = 0;
      this.segmentCount = 0;
      this.mainVehicleCount = 0;
      this.modelCount = 0;
      this.tonnageCount = 0;
      this.fuelCount = 0;
      this.acCount = 0;
      this.bodyCount = 0;
      this.loadBodyCount = 0;
      this.cabinTypeCount = 0;
      this.wheelCount = 0;
      this.wheelbasecount=0;
    }
    let filterValue: any = []
    this.vehicle_acpplication = [];
    this.actual_lob_name = [];
    this.ModelName = [];
    this.ppl_name = [];
    this.gvwFilterSelected = [];
    this.fuelFilterSelected = [];
    this.acFilterSelected = [];
    this.loadBodyFilterSelected = [];
    this.cabinTypeFilterSelected = [];
    this.wheelsFilterSelected = [];
    this.bodyTypeFilterSelected = [];
    this.minValue = 0;
      filterValue = JSON.parse(localStorage.getItem("unbxFilterValue"))
      // if (filterValue?.length > 0) {
      //   for (let i = 0; i < filterValue?.length; i++) {
      //     for (let j = 0; j < this.final_filter?.length; j++) {
      //       if (filterValue[i].category == this.final_filter[j].category) {
      //         if (this.final_filter[j].values) {

      //           for (let k = 0; k < this.final_filter[j].values?.length; k++) {
      //             if (this.final_filter[j].values[k].value == filterValue[i].event) {
      //               this.final_filter[j].values[k].checked = false;
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      //   localStorage.removeItem("unbxFilterValue");
      //   this.updateFilterSelectedArrays();
      //   if (flag != 'Explore') {
      //     this.behaviourSub.filterValue.next('Clear')
      //   }
      // }
      // else{

      //   this.final_filter.forEach((element)=>{
      //     element.values.forEach(element1 => {
      //       element1.checked=false
      //     });
      //   })
      //   localStorage.removeItem("unbxFilterValue");
      //   this.updateFilterSelectedArrays();
      //   if (flag != 'Explore') {
      //     this.behaviourSub.filterValue.next('Clear')
      //   }
      // }
      this.final_filter.forEach((element)=>{
        element.values.forEach(element1 => {
          element1.checked=false
        });
      })
      localStorage.removeItem("unbxFilterValue");
        this.updateFilterSelectedArrays();
        if (flag != 'Explore') {
          this.behaviourSub.filterValue.next('Clear')
      }
    }
  }

  searchFilter(rowData, value) {
    if (isPlatformBrowser(this.platformId)) {

      // localStorage.setItem('tempFilterArrayrowdata', JSON.stringify(rowData))
      // localStorage.setItem('tempFilterArrayvalue', JSON.stringify(value))
        var index = this.final_filter.findIndex((item: any) => item.facetName === rowData.facetName);

        if (index !== -1) {
            if (!this.final_filter[index].originalValues) {
                this.final_filter[index].originalValues = [...this.final_filter[index].values];
            }

            let temp = this.final_filter[index].originalValues.filter(obj => obj.value?.toLowerCase().includes(value?.toLowerCase()));

            this.final_filter[index].values = temp?.length > 0 ? temp :[];
        }

    }

}

  removeFromArray(data) {
    if (this.vehicle_acpplication.find(element => element == data)) {
      let i = this.vehicle_acpplication.findIndex(element => element == data)
      this.vehicle_acpplication.splice(i, 1);
    }
    if (this.actual_lob_name.find(element => element == data)) {
      let i = this.actual_lob_name.findIndex(element => element == data)
      this.actual_lob_name.splice(i, 1);
    }
    if (this.ModelName.find(element => element == data)) {
      let i = this.ModelName.findIndex(element => element == data)
      this.ModelName.splice(i, 1);
    }
    if (this.ppl_name.find(element => element == data)) {
      let i = this.ppl_name.findIndex(element => element == data)
      this.ppl_name.splice(i, 1);
    }
    if (this.gvwFilterSelected.find(element => element == data)) {
      let i = this.gvwFilterSelected.findIndex(element => element == data)
      this.gvwFilterSelected.splice(i, 1);
    }
    if (this.fuelFilterSelected.find(element => element == data)) {
      let i = this.fuelFilterSelected.findIndex(element => element == data)
      this.fuelFilterSelected.splice(i, 1);
    }
    if (this.acFilterSelected.find(element => element == data)) {
      let i = this.acFilterSelected.findIndex(element => element == data)
      this.acFilterSelected.splice(i, 1);
    }
    if (this.loadBodyFilterSelected.find(element => element == data)) {
      let i = this.loadBodyFilterSelected.findIndex(element => element == data)
      this.loadBodyFilterSelected.splice(i, 1);
    }
    if (this.cabinTypeFilterSelected.find(element => element == data)) {
      let i = this.cabinTypeFilterSelected.findIndex(element => element == data)
      this.cabinTypeFilterSelected.splice(i, 1);
    }
    if (this.wheelsFilterSelected.find(element => element == data)) {
      let i = this.wheelsFilterSelected.findIndex(element => element == data)
      this.wheelsFilterSelected.splice(i, 1);
    }
    if (this.bodyTypeFilterSelected.find(element => element == data)) {
      let i = this.bodyTypeFilterSelected.findIndex(element => element == data)
      this.bodyTypeFilterSelected.splice(i, 1);
    }

  }
  onbudegetChange(event: any, cateogry: any) {
    if (isPlatformBrowser(this.platformId)) {
      let filterValue: any = []
      filterValue = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
      if (filterValue?.length > 0) {
        if (cateogry == 'price_from') {
          this.minValue = event.target.value
          let i = filterValue.findIndex(element => element.category == 'price_from')
          filterValue.splice(i, 1);
          let t = filterValue.findIndex(element => element.category == 'price_to')
          filterValue.splice(t, 1);
          localStorage.setItem("unbxFilterValue", JSON.stringify(filterValue))
          this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
          this.ssoptions.floor = 0
          this.minValue = this.minValue
          this.filterList.push({ event: this.minValue, category: cateogry })
          this.filterList.push({ event: this.maxValue, category: 'price_to' })
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
        }
        if (cateogry == 'price_to') {
          this.maxValue = event.target.value
          let i = filterValue.findIndex(element => element.category == 'price_from')
          filterValue.splice(i, 1);
          let t = filterValue.findIndex(element => element.category == 'price_to')
          filterValue.splice(t, 1);
          localStorage.setItem("unbxFilterValue", JSON.stringify(filterValue))
          this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
          this.filterList.push({ event: this.minValue, category: 'price_from' })
          this.filterList.push({ event: this.maxValue, category: cateogry })
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
        }
      }
      else {
        if (cateogry == 'price_from') {
          let i = this.filterList.findIndex(element => element.category == 'price_from')
          this.filterList.splice(i, 1);
          let t = this.filterList.findIndex(element => element.category == 'price_to')
          this.filterList.splice(t, 1);
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
          this.ssoptions.floor = 0
          this.minValue = event.target.value
          this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
          this.filterList.push({ event: this.minValue, category: cateogry })
          this.filterList.push({ event: this.maxValue, category: 'price_to' })
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
        }
        if (cateogry == 'price_to') {
          let i = this.filterList.findIndex(element => element.category == 'price_from')
          this.filterList.splice(i, 1);
          let t = this.filterList.findIndex(element => element.category == 'price_to')
          this.filterList.splice(t, 1);
          this.maxValue = event.target.value
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
          this.filterList.push({ event: this.minValue, category: 'price_from' })
          this.filterList.push({ event: this.maxValue, category: cateogry })
          localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
        }
      }
      let data: any = {};
      if (cateogry == 'price_from') {
        data['price_from'] = event.target.value;
      }
      if (cateogry == 'price_to') {
        data['price_to'] = event.target.value;
      }
      this.behaviourSub.filterValue.next(null)
    }
  }

  sliderEvent() {
    if (isPlatformBrowser(this.platformId)) {
    let filterValue: any = []
    filterValue = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
    if (filterValue?.length > 0) {
      let i = filterValue.findIndex(element => element.category == 'price_from')
      filterValue.splice(i, 1);
      let t = filterValue.findIndex(element => element.category == 'price_to')
      filterValue.splice(t, 1);
      localStorage.setItem("unbxFilterValue", JSON.stringify(filterValue))
      this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
      this.filterList.push({ event: this.minValue, category: 'price_from' })
      this.filterList.push({ event: this.maxValue, category: 'price_to' })
      localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
    }
    else {
      this.filterList = localStorage.getItem("unbxFilterValue") ? JSON.parse(localStorage.getItem("unbxFilterValue")) : []
      this.filterList.push({ event: this.minValue, category: 'price_from' })
      this.filterList.push({ event: this.maxValue, category: 'price_to' })
      localStorage.setItem("unbxFilterValue", JSON.stringify(this.filterList))
    }

    this.behaviourSub.filterValue.next(null)
  }
  }

  updateSliderRange() {
    this.floorValue = 50;
    this.ceilValue = 200;
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }

  closeFilter() {
    this.behaviourSub.isMobileFilter.next('Close');
  }
  clearFi(){
    this.behaviorService.isClearfilter.next(true)
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
